import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { getStr } from "../creator/utils/simpleLocalisation";


export class gameClassroom extends cDisplay {

  private code: string[] = ['0','0','0']
  private correct:string[] = ["urne","stifte","trennwand","musterbogen","tisch","stuhl"]
  private collected:string[] = []
  private score:number = 4
  private textData:any

  init(){
    super.init()
    console.log('GAME gameClassroom')

    this.collected = []
    var cS:cScene = this.scene as cScene;  
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      
      switch (b.command){
        case 'handle_drop':
      }
    })
  }


  private drag:Phaser.GameObjects.Sprite = null
  private dropTarget:cSprite
  private curname: string


  removeFromWagon(name:string){
    var removeName = '';
    switch (name){
      case 'target_stuhl_rechts':
      case 'target_tisch_links':
        //do nothing        
        break;
      case 'target_stuhl_links':
        removeName = 'stuhl'
        break;
      case 'target_tisch_rechts':
        removeName = 'tisch'
        break;
      default:
        var [x,nm] = name.split('_')
        removeName = nm
    }
    if (removeName !== ''){
      var holder = this.getByName('bollerwagen_holder')
      var ref = holder.getByName('item_'+removeName)
      if (ref){
        ref.visible = false
      }else{
        console.error('NOT FOUND',removeName)
      }
    }

  }


  buildScene(){    
    var cS:cScene = this.scene as cScene;    
    super.buildScene();


    var dArea = this.getByName('dragArea');
    var container:cContainer = this.getByName('drag_items') as cContainer
    var sc:cScene = this.scene as cScene;
    dArea.setInteractive()
    
    var dragItemsName = ['target_sichtschutz','target_stuhl_rechts','target_stuhl_links','target_tisch_links','target_tisch_rechts','target_stuhlflip','target_muster','target_stifte','target_urne'];

    sc.input.on('pointermove',(r)=>{
      if (this.drag){
        this.drag.x = r.x
        this.drag.y = r.y
      }
    })

    sc.input.on('pointerup',()=>{
      if (this.drag == null) return
      if (this.dropTarget){
        var dist = Phaser.Math.Distance.Between(this.drag.x,this.drag.y,this.dropTarget.x,this.dropTarget.y)        
        if (dragItemsName.length === 0 ){
          this.dropTarget.alpha = 1;
          sc.triggerSceneEvent('completed')
          this.removeFromWagon(this.curname);
          ['dragArea','bollerwagen','bollerwagen_holder'].forEach( key=>this.getByName(key).visible = false )
        }else if (dist < 30){
          this.dropTarget.alpha = 1;
          this.removeFromWagon(this.curname);
          sc.triggerSceneEvent('drop_ok',{'hintpos':'100x100'})
        }else{
          sc.triggerSceneEvent('drop_error')     
          dragItemsName.unshift(this.curname)     
        }
      }
                  
      this.drag.destroy();
      this.drag = null

    })

    dArea && dArea.on('pointerdown',(r)=>{
      
      if (this.drag !== null) {
        this.drag.destroy();
        this.drag = null          
      }

      this.curname = dragItemsName.shift()
      var item:cSprite = container.getByName(this.curname) as cSprite;
      console.log( item.frame)


      
      //this.drag = Phaser.Utils.Objects.Clone(item) as any
      this.drag = new Phaser.GameObjects.Sprite(sc,r.x,r.y,item.texture.key, item.frame.name)
      this.drag.scaleX = item.scaleX
      this.drag.scaleY = item.scaleY
      sc.add.existing(this.drag)    
      this.dropTarget = item


      sc.triggerSceneEvent('startdrag')
    })
  }
  

}
